import { IApiRole } from '@mitie/risk-register-api-types';

import * as Api from './api';

export function getAll() {
	return Api.get<IApiRole[]>('users/roles');
}
